// iter160 — BFR admin bottom navigation. Three tabs mirroring the main
// app's mobile-first nav: Booking Calendar / Properties / Email. Active tab
// tints in navy #1B2A7B; inactive tabs render slate-500. Fixed to the bottom
// of the viewport and shared across every /admin/* screen through
// AdminLayout in App.js.

import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { CalendarDays, Building2, Mail } from 'lucide-react';

const NAV_ITEMS = [
  { path: '/admin/calendar', icon: CalendarDays, label: 'Booking Calendar', testid: 'admin-nav-calendar' },
  { path: '/admin',          icon: Building2,    label: 'Properties',       testid: 'admin-nav-properties' },
  { path: '/admin/email',    icon: Mail,         label: 'Email',            testid: 'admin-nav-email' },
];

const isActivePath = (currentPath, itemPath) => {
  if (itemPath === '/admin') {
    // Dashboard is the "Properties" tab. Also match nested /admin/property/*
    // detail pages so users still see Properties highlighted while drilled in.
    return currentPath === '/admin' || currentPath.startsWith('/admin/property');
  }
  return currentPath === itemPath || currentPath.startsWith(`${itemPath}/`);
};

const AdminBottomNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 bg-[#1B2A7B] border-t border-[#152163] px-2 py-2 shadow-[0_-4px_16px_rgba(11,24,82,0.25)] z-30 safe-area-bottom"
      data-testid="admin-bottom-navigation"
    >
      <div className="flex items-center justify-around max-w-lg mx-auto">
        {NAV_ITEMS.map((item) => {
          const Icon = item.icon;
          const active = isActivePath(location.pathname, item.path);
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              data-testid={item.testid}
              aria-current={active ? 'page' : undefined}
              className={`relative flex flex-col items-center py-1.5 px-3 rounded-xl transition-colors ${
                active ? 'text-white' : 'text-white/60 hover:text-white/80'
              }`}
            >
              <div className={`p-2 rounded-lg transition-colors ${active ? 'bg-white/15' : ''}`}>
                <Icon className="w-5 h-5" />
              </div>
              <span className={`text-[11px] mt-0.5 font-medium ${active ? 'text-white' : ''}`}>
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default AdminBottomNavigation;
